export enum FormikElement {
  TEXT_INPUT = 'textInput',
  NUMERIC_INPUT = 'numericInput',
  SELECT = 'select',
  EDITOR = 'editor',
  TEXT_AREA = 'textArea',
  LOAD_BUTTON = 'loadButton',
  RADIO_INPUT = 'radioInput',
}
